import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type RunSkill = components["schemas"]["Skill"];

/**
 * Thin chat-local fetcher over the shared skills endpoint (features don't import
 * each other — precedent: `getAssistant.ts`). It uses the same query key as the
 * skills manager, so the composer slash typeahead and the manager share one
 * cache: create/edit/delete over there is instantly reflected here.
 */
export async function listMyRunSkills(): Promise<RunSkill[]> {
  const res = unwrap(await api.GET("/v1/skills/me", {})) as { data?: RunSkill[] };
  return res.data ?? [];
}
